import { createSelector } from '@ngrx/store';
import { getCitation } from './get.citations';

export const allowCreation = createSelector(
  getCitation,
  ({
    isTrackChangesEnabled: rhpTrackChangesEnabled,
    createdReferenceId,
  }): boolean => !!(rhpTrackChangesEnabled && createdReferenceId)
);
